import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-62">
      <div className="max-w-3xl mx-auto" data-id="element-63">
        <FadeIn className="bg-surface border border-mint/20 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-xl" data-id="element-64">
          <div className="absolute top-0 left-0 w-full h-2 bg-mint" data-id="element-65" />

          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-mint/10 mb-4" data-id="element-66">
            <ShieldCheck size={40} className="text-mint" data-id="element-67" />
          </div>

          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4 text-mint" data-id="element-68">
            GARANTÍA SALUD EN TU PLATO™ — 7 DÍAS
          </h2>

          <div className="space-y-4 text-lg md:text-xl text-white/80 max-w-2xl mx-auto" data-id="element-69">
            <p data-id="element-70">
              Abrís los 6 tomos. Revisás los bonos. Los usás en consulta si
              querés.
            </p>
            <p className="font-bold text-mint" data-id="element-71">
              Si en 7 días no era lo que esperabas: Te devolvemos el 100%.
            </p>
            <p data-id="element-72">Sin preguntas. Sin formularios. Sin drama.</p>
          </div>
        </FadeIn>
      </div>
    </section>;
}